// src/components/pricingUnits/Table/PricingUnitsTableColumns.jsx

const PricingUnitsTableColumns = [
    { id: "name_ar", labelAr: "الاسم بالعربي", labelEn: "Arabic Name", sortable: true },
    { id: "name_en", labelAr: "الاسم بالإنجليزي", labelEn: "English Name", sortable: true },
    { id: "code", labelAr: "الكود", labelEn: "Code", sortable: true },
    { id: "status", labelAr: "الحالة", labelEn: "Status", sortable: false },
];

export default PricingUnitsTableColumns;
